import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Box, Link } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { useFormik } from "formik";
import moment from "moment";
import { searchData, AddData, searchDataWithGet } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { getOrderStatusAction } from "src/app-redux/work-order/actions/workorderActions";
import { IInvoicesItem } from "src/common/typings/invoices";
import { getLocalDateTime, getUTCDateTime } from "src/common/utils/app.util";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import { moneyformatter } from "src/common/utils/helpers";
import { Loader } from "src/components/atoms/Loader";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { QuickPaySetting } from "./quickPaySetting";
import { Sticky } from "./stickyinfo";

export default function InvoicesList() {
  const dispatch = useDispatch();
  const { winHeight } = useMyWinHeightContext();
  const [loader, setLoader] = useState(false);
  const [isQuickPaySetting, setIsQuickPaySetting] = useState(false);
  const isQuickPaySettingRef = useRef(isQuickPaySetting);
  const [gData, setGData] = useState<IInvoicesItem[]>([]);
  const [drawerStatus, setdrawerStatus] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<any>({});
  const [quickPaySettingList, setQuickPaySettingList] = React.useState<any[]>([]);
  const [manualQuickPaySettingList, setManualQuickPaySettingList] = React.useState<any[]>([]);

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      type: "number",
      width: 100,
      renderCell: function customCell(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              if (!params.row.qpExclude) {
                if (isQuickPaySettingRef.current) {
                  dispatch(
                    addNotificationAction({
                      message:
                        "QuickPay is already opted-in for your company. Please opt-out in order to request QuickPay for individual invoices.",
                      options: { variant: "warning" },
                    })
                  );
                } else {
                  isDrawerOpen(params.row);
                }
              } else {
                dispatch(
                  addNotificationAction({
                    message:
                      "QuickPay is disabled for your company. Please contact The Facilities Group support.",
                    options: { variant: "warning" },
                  })
                );
              }
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "invoiceNum",
      headerName: "Invoice #",
      type: "string",
      width: 150,
    },
    {
      field: "payAmt",
      headerName: "Pay Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "invoiceAmt",
      headerName: "Invoice Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "expectedDate",
      headerName: "Due Date",
      width: 150,
      type: "date",
    },
    {
      field: "recievedDate",
      headerName: "Invoice Date",
      width: 170,
      type: "date",
    },
    {
      field: "qpAmount",
      headerName: "QuickPay Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "qpPercent",
      headerName: "QuickPay %",
      type: "number",
      width: 150,
    },
  ];

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setLoader(true);
    await getQuickpaysettingList();
    await getManualQuickpaysettingList();
    await dispatch(getOrderStatusAction());
    await handleSearch();
    setLoader(false);
  };
  useEffect(() => {
    isQuickPaySettingRef.current = isQuickPaySetting;
  }, [isQuickPaySetting]);
  const formik = useFormik({
    initialValues: {
      status: "Unpaid",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { status, startDate, endDate } = values;
    const body = {
      status: status || "",
      startDate: startDate || null,
      endDate: endDate || null,
    };
    setGData([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-vendor-invoices-unpaid-for-quick-pay", JSON.stringify(body))
      );
      if (results?.vendorInvoices) {
        const transformedData = results.vendorInvoices.map((invoice: any) => {
          return {
            ...invoice,
            expectedDate: getLocalDateTime(invoice.expectedDate, "MM/DD/YYYY"),
            recievedDate: getLocalDateTime(invoice.recievedDate, "MM/DD/YYYY"),
          };
        });
        setGData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };

  const isDrawerOpen = (parms: any) => {
    setSelectedData(parms);
    setdrawerStatus(true);
  };
  const submitForm = async (item: any) => {
    setdrawerStatus(false);
    setLoader(true);
    const body = {
      id: selectedData.id,
      percentage: item.per,
      Amount: parseFloat(item.payAmt),
      isMailingFeeActive: item.mailingfees || false,
      FedexFee: item.fedexFee || 0,
      dueDate: getUTCDateTime(item?.payDate?.format("YYYY-MM-DD")) || "",
    };
    try {
      await dispatch(
        AddData(
          "/update-vendor-inv-head-quick-pay",
          "Quick Pay added successfully",
          JSON.stringify(body)
        )
      );
      handleSearch();
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const getQuickpaysettingList = async () => {
    try {
      const results: any = await dispatch(searchDataWithGet("/get-vendor-quickpay-setting/"));
      setQuickPaySettingList(results?.quickpaysetting || []);
    } catch (error) {
      console.log(error);
    }
  };
  const getManualQuickpaysettingList = async () => {
    try {
      const results: any = await dispatch(
        searchDataWithGet("/get-vendor-manual-quickpay-setting/")
      );
      setManualQuickPaySettingList(results?.quickpaysetting || []);
    } catch (error) {
      console.log(error);
    }
  };
  const dppr = 1000;
  const gridMaxHeight = winHeight - 400;
  return (
    <>
      <Loader open={loader} />
      <Box mb={1}>
        <CommonDataGridPage
          module={"QuickPay"}
          heading={"Automatic QuickPay"}
          heading1={"List of QuickPay"}
          linkTo="quick-pay"
          pageTitle="TFG | Portal | Quick Pay"
          forQuickPay
        >
          <>
            <Box mt={0} p={1} style={{ background: "#F3F3F3" }}>
              TFG’s new <strong>Automatic QuickPay</strong> program allows you to select from a
              various range of expedited payment terms to facilitate your business needs. If
              enrolled in Automatic QuickPay, all future payments will be made based on the payment
              terms selected. You will no longer need to log in to the portal and manually select
              QuickPay as payments get posted.
            </Box>
            <QuickPaySetting
              setIsQuickPaySetting={(status: boolean) => setIsQuickPaySetting(status)}
              refrishGridData={handleSearch}
              settingData={quickPaySettingList}
            />
          </>
        </CommonDataGridPage>
      </Box>
      <CommonDrawer
        heading={"QuickPay"}
        isOpen={drawerStatus}
        closeDrawer={() => {
          setdrawerStatus(false);
        }}
        drawerWidth={650}
      >
        <>
          <Sticky
            stickyInfo={selectedData}
            setdrawerStatus={() => setdrawerStatus(false)}
            submitForm={submitForm}
            settingData={manualQuickPaySettingList}
          />
        </>
      </CommonDrawer>

      <CommonDataGridPage
        module={"QuickPay"}
        heading={"List of QuickPay"}
        linkTo="quick-pay"
        pageTitle="TFG | Portal | Quick Pay"
        notShowTabHeading
        GridDataComp={
          <>
            <CommonXGrid
              rows={gData}
              columns={columns}
              //loader={loader}
              defaultPerPageRecord={dppr}
              height={gridMaxHeight}
              modifyColumns
            />
          </>
        }
      >
        <></>
      </CommonDataGridPage>
    </>
  );
}
